module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external "aws-sdk/global"
// module id = 7
// module chunks = 0